// extracted by mini-css-extract-plugin
export default {"calculatingLayoutSpinnerContainer":"j2GVuZ7","calculatingLayoutSpinnerContent":"nNF6ZmF","calculatingLayoutSpinnerLabel":"vMdgEeK"};